import { apiClient } from 'pobble-components/dist/api'

const apiGetAssessmentFile = (assessmentFileId, params) =>
  apiClient.get(`v3/assessment_files/${assessmentFileId}`, { params })

const apiInviteToAssessmentFileBulk = (data, params) =>
  apiClient.post('/v3/bulk_invite_guest_moderators', data, { params })

const apiMarkAsExample = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/mark_as_example`)

const apiUnmarkAsExample = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/unmark_as_example`)

const apiMarkAsTrainingMaterial = assessmentFileId =>
  apiClient.put(
    `v3/assessment_files/${assessmentFileId}/mark_as_training_material`
  )

const apiUnmarkAsTrainingMaterial = assessmentFileId =>
  apiClient.put(
    `v3/assessment_files/${assessmentFileId}/unmark_as_training_material`
  )

const apiGetExamples = (schoolOrganisationFilter, params) =>
  apiClient.get(
    `v3/assessment_files?limit=50&${
      schoolOrganisationFilter
        ? 'examples_in_school_organisation=true'
        : 'example=true&created_by_pobbler=1'
    }`,
    { params }
  )

const apiGetTrainings = (schoolOrganisationFilter, params) =>
  apiClient.get(
    `v3/assessment_files?limit=50&training_material=true&created_by_pobbler=1`,
    { params }
  )

const apiCopyAssessmentFile = (assessmentFileId, params) =>
  apiClient.post(`v3/assessment_files/${assessmentFileId}/duplicate`, {
    params
  })

const apiGetSchoolFiles = params =>
  apiClient.get('v3/assessment_files?limit=350&school_search=true', { params })

const apiGetOrganisationFiles = (benchmarkFilter, params) =>
  apiClient.get(
    `v3/assessment_files?limit=50&in_school_organisation=true&benchmarked=${benchmarkFilter}`,
    { params }
  )

const apiEditTitle = (id, data, params) =>
  apiClient.put(`v3/assessment_files/${id}/`, data, {
    params
  })

const apiGetStudentWorks = (studentId, params) =>
  apiClient.get(`v3/accounts/${studentId}`, { params })

const apiAddWorkToAssessmentFile = (workId, assessmentFileId, params) =>
  apiClient.post(
    `v3/assessment_file_works?include=assessment_file.details,assessment_file.works,assessment_file.work.names,assessment_file.work.media,assessment_file.work.medium.image,assessment_file.work.timestamps,assessment_file.student_type.account,assessment_file.work.medium.thumb`,
    { id: assessmentFileId, work_ids: [workId] },
    { params }
  )

const apiRemoveWorkFromAssessmentFile = (workId, assessmentFileId) => {
  return apiClient.post(
    `v3/assessment_files/${assessmentFileId}/remove_work?include=assessment_file.details,assessment_file.works,assessment_file.work.names,assessment_file.work.media,assessment_file.work.medium.image,assessment_file.work.timestamps,assessment_file.student_type.account,assessment_file.work.medium.thumb`,
    { work_id: workId }
  )
}

const apiCloseAssessmentFile = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/mark_as_closed`)

const apiReopenAssessmentFile = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/unmark_as_closed`)

const apiArchiveAssessmentFile = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/mark_as_archived`)

const apiUnarchiveAssessmentFile = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/unmark_as_archived`)

const apiMarkAsBenchmark = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/mark_as_benchmark`)

const apiUnmarkAsBenchmark = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/unmark_as_benchmark`)

const apiGetYearGroups = params => apiClient.get('/v3/year_groups', { params })

const apiMarkAsPremium = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/mark_as_premium`)

const apiUnmarkAsPremium = assessmentFileId =>
  apiClient.put(`v3/assessment_files/${assessmentFileId}/unmark_as_premium`)

export {
  apiGetAssessmentFile,
  apiInviteToAssessmentFileBulk,
  apiMarkAsExample,
  apiUnmarkAsExample,
  apiGetExamples,
  apiCopyAssessmentFile,
  apiGetSchoolFiles,
  apiEditTitle,
  apiGetStudentWorks,
  apiAddWorkToAssessmentFile,
  apiCloseAssessmentFile,
  apiReopenAssessmentFile,
  apiArchiveAssessmentFile,
  apiUnarchiveAssessmentFile,
  apiMarkAsBenchmark,
  apiUnmarkAsBenchmark,
  apiRemoveWorkFromAssessmentFile,
  apiGetOrganisationFiles,
  apiMarkAsTrainingMaterial,
  apiUnmarkAsTrainingMaterial,
  apiGetTrainings,
  apiGetYearGroups,
  apiMarkAsPremium,
  apiUnmarkAsPremium
}
